import React from 'react';
import PropTypes from 'prop-types';

import mergeClassName from 'merge-class-names';

import { createUseStyles } from '../../palette';
import decorate from '../../common/utils/decorate';

const useMainStyles = createUseStyles((theme) => ({
  '@keyframes skeleton-shimmer': {
    '100%': {
      transform: 'translateX(100%)'
    }
  },

  skeleton: {
    backgroundColor: '#dddbdd',

    display: 'inline-block',
    overflow: 'hidden',

    position: 'relative',
    width: '100%',
    height: '1em',
    minWidth: 150,

    '&::after': {
      backgroundImage:
        'linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 40%, rgba(255, 255, 255, 0.8) 60%, rgba(255, 255, 255, 0))',
      animation: '$skeleton-shimmer 2s infinite',
      transform: 'translateX(-100%)',

      content: '""',

      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },

    '&:nth-child(3n)': {
      width: '80%'
    }
  }
}));

const useVariantStyles = createUseStyles((theme) => ({}));

export default decorate(
  class extends React.PureComponent {
    static decorateWith = {
      classes: {
        main: useMainStyles,
        variant: useVariantStyles
      }
    };

    static propTypes = {
      variant: PropTypes.string
    };

    static defaultProps = {};

    constructor(props) {
      super(props);
    }

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const { classes, children, variant, className, ...props } = this.props;

      const mergedClassName = mergeClassName(
        classes.main.skeleton,
        variant && classes.variant[variant],
        className
      );

      return <span {...props} className={mergedClassName} />;
    }
  }
);
